import Alert from "../../components/alert";
import { connect } from "react-redux";
import { FormattedDollars } from "../../components/formatted-currency";
import { getSession, getWithdraw } from "../../selectors";
import { Link, withRouter } from "react-router-dom";
import React from "react";
import requireAuthentication from "../../components/higher-order/require-authentication";
import Steps from "../../components/withdraw/steps";
import OpenIntercomLink from "../../components/open-intercom-link";

class ConfirmationPage extends React.PureComponent {
  constructor(props) {
    super(props);

    var { withdraw, history } = props;
    if (!withdraw.get("amount") || !withdraw.get("confirmed")) {
      history.push("/withdraw");
    }
  }

  render() {
    var { session, withdraw } = this.props;
    var balance = session.get("money_balance");
    var amount = withdraw.get("amount");
    var previousBalance = balance + amount;

    var message = (
      <Alert fixed icon="dw-checkmark3" title="Transaction Complete!" type="notification--success">
        You will receive a check for
        {" "}

        <FormattedDollars value={amount} />

        {" "}
        in the mail in 7 to 10 business days.
      </Alert>
    );
    if (withdraw.get("paymentMethod") === "ach") {
      message = (
        <Alert fixed icon="dw-checkmark3" title="Transaction Complete!" type="notification--success">
          Your ACH withdrawal request for
          {" "}

          <FormattedDollars value={amount} />

          {" "}
          has been received. Please allow up to 7 business days for processing. For questions, please

          {" "}

          <OpenIntercomLink>
            contact support
          </OpenIntercomLink>
          .
        </Alert>
      );
    }

    return (
      <div>
        {message}

        <div className="l-wrapper">
          <div className="l-content l-content--80-percent">

            <Steps isConfirmation session={session} withdraw={withdraw} />

            <h1 className="text-center">
              Withdrawal Confirmation
            </h1>

            <h2 className="margin-top--is-5">
              Transaction Summary
            </h2>

            <div className="summary">
              <dl className="summary_row">
                <dt>
                  Previous Account Balance:
                </dt>

                <dd>
                  <FormattedDollars showCents value={previousBalance} />
                </dd>
              </dl>

              <dl className="summary_row">
                <dt>
                  Total Withdrawal:
                </dt>

                <dd>
                  -
                  <FormattedDollars showCents value={amount} />
                </dd>
              </dl>

              <dl className="summary_row summary_row--total">
                <dt>
                  New Account Balance:
                  {" "}

                  <button className="dw-help_outline dw--1-25x" type="button" />
                </dt>

                <dd>
                  <FormattedDollars showCents value={balance} />
                </dd>
              </dl>
            </div>

            <p className="margin-top--is-40 margin-bottom--is-40 text-center">
              <Link className="btn btn--large btn--emphasis btn--primary" to="/">
                Browse Tournaments
              </Link>
            </p>

          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    session: getSession(state),
    withdraw: getWithdraw(state)
  };
}

export default connect(select)(requireAuthentication(withRouter(ConfirmationPage)));
